import {
  PELL_STRIKE_MIN_ARC_DEFAULT_M,
  PELL_STRIKE_MIN_ARC_MAX_M,
  PELL_STRIKE_MIN_ARC_MIN_M,
  PELL_STRIKE_MIN_SPEED_DEFAULT_MPS,
  PELL_STRIKE_MIN_SPEED_MAX_MPS,
  PELL_STRIKE_MIN_SPEED_MIN_MPS,
} from '../config/constants';
import { getSetting, setSetting } from '../settings/userSettings';

/**
 * Typed adapters for the pell/drill strike-validity gates (min impact speed + min swing
 * arc), persisted via the central user-settings store. Mirrors `targetsSettings.ts`.
 */

function loadNumber(value: number, min: number, max: number, def: number): number {
  return isFinite(value) && value >= min && value <= max ? value : def;
}

/** Minimum impact tip speed (m/s) for a colpo to count on the pell / in a drill. */
export function loadPellMinSpeed(): number {
  return loadNumber(
    getSetting('pellMinSpeed'),
    PELL_STRIKE_MIN_SPEED_MIN_MPS,
    PELL_STRIKE_MIN_SPEED_MAX_MPS,
    PELL_STRIKE_MIN_SPEED_DEFAULT_MPS,
  );
}

export function savePellMinSpeed(v: number): void {
  setSetting('pellMinSpeed', v);
}

/** Minimum swing-arc length (m) for a colpo to count on the pell / in a drill. */
export function loadPellMinArc(): number {
  return loadNumber(
    getSetting('pellMinArc'),
    PELL_STRIKE_MIN_ARC_MIN_M,
    PELL_STRIKE_MIN_ARC_MAX_M,
    PELL_STRIKE_MIN_ARC_DEFAULT_M,
  );
}

export function savePellMinArc(v: number): void {
  setSetting('pellMinArc', v);
}
